import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, FileText, BarChart3, Wallet, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

export default function HamburgerMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  // Close on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const handleLogout = async () => {
    setOpen(false);
    try { await signOut(); }
    catch { toast.error('Failed to sign out'); }
  };

  const handleNav = (path) => {
    setOpen(false);
    navigate(path);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen(prev => !prev)}
        className="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors duration-150"
        aria-label="Navigation menu"
        aria-expanded={open}
      >
        <Menu className="h-5 w-5" />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1.5 w-48 bg-white rounded-lg shadow-[0_8px_30px_rgba(0,0,0,0.12)] border py-1 z-50 animate-in fade-in slide-in-from-top-2 duration-150">
          <button
            onClick={() => handleNav('/dashboard')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm transition-colors ${
              isActive('/dashboard')
                ? 'text-primary bg-primary/5 font-medium'
                : 'text-foreground hover:bg-muted/50'
            }`}
          >
            <FileText className="h-4 w-4" />
            Invoices
          </button>
          <button
            onClick={() => handleNav('/ops')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm transition-colors ${
              isActive('/ops')
                ? 'text-primary bg-primary/5 font-medium'
                : 'text-foreground hover:bg-muted/50'
            }`}
          >
            <BarChart3 className="h-4 w-4" />
            Operations
          </button>
          <button
            onClick={() => handleNav('/payroll')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm transition-colors ${
              isActive('/payroll')
                ? 'text-primary bg-primary/5 font-medium'
                : 'text-foreground hover:bg-muted/50'
            }`}
          >
            <Wallet className="h-4 w-4" />
            Payroll
          </button>
          <div className="border-t my-1" />
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-muted-foreground hover:text-red-600 hover:bg-red-50/50 transition-colors"
          >
            <LogOut className="h-4 w-4" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
